/* @flow */
const BASE_URL = 'https://www.google.com/calendar/render?action=TEMPLATE&';

const HOUR_MS = 60 * 60 * 1000;

function formatTime(date: Date) {
  return date.toISOString().replace(/-|:|\.\d\d\d/g, '');
}

export function buildGoogleCalendarUrl(title: string, start: Date, description: ?string, location: ?string): ?string {
  const end = new Date(start.getTime() + 1 * HOUR_MS);
  try {
    return createGoogleCalLink(title, start, end, description, location);
  } catch (e) {
    return null;
  }
}

export function createGoogleCalLink(title: string, startTime: Date, endTime: Date, details: ?string, location: ?string) {
  if (new Date(startTime) > new Date(endTime)) {
    throw new Error('Start time is after end time');
  }

  if (!startTime) {
    throw new Error('Start time not supplied');
  }

  if (!endTime) {
    throw new Error('End time not supplied');
  }

  const formattedStartTime = formatTime(startTime);
  const formattedEndTime = formatTime(endTime);
  const dates = `dates=${formattedStartTime}/${formattedEndTime}&`;

  title = title ? `text=${encodeURI(title)}&` : '';
  details = details ? `details=${encodeURI(details)}&` : '';
  location = location ? `location=${encodeURI(location)}&` : '';

  return `${BASE_URL}${title}${dates}` + details + location + 'sf=true&output=xml';
}



// WEBPACK FOOTER //
// ./src/lib/createGoogleCalLink.js